<template>
    <div class="min-h-screen bg-surface-muted">
        <div class="flex min-h-screen">
            <section class="relative flex min-h-screen basis-full flex-col bg-white lg:basis-1/2">
                <div class="flex flex-1 min-h-0 items-center justify-center overflow-y-auto px-8 py-12">
                    <div class="w-full max-w-[28rem]">
                        <div class="mb-8">
                            <h1 class="text-4xl font-semibold text-gray-900">{{ pageTitle }}</h1>
                            <p v-if="pageDescription" class="mt-4 text-[0.95rem] leading-[1.6] text-ink">{{ pageDescription }}</p>
                        </div>
                        <div>
                            <router-view/>
                        </div>
                    </div>
                </div>
                <div class="shrink-0 bg-white px-8 pb-14 pt-10">
                    <div class="mx-auto flex w-full max-w-[28rem] items-end min-h-[5.5rem]">
                        <legal-links-menu
                            link-class="text-[0.95rem] font-normal leading-[1.6] text-ink-muted no-underline hover:text-ink"
                            wrapper-class="flex flex-wrap gap-x-4 gap-y-2 text-[0.95rem] leading-[1.6] text-ink-muted"
                        />
                    </div>
                </div>
            </section>
            <aside class="relative hidden min-h-screen overflow-hidden bg-[#202830] bg-cover bg-center bg-no-repeat lg:block lg:basis-1/2" :style="visualPanelStyle">
                <div class="auth-shell__visual-overlay absolute inset-0"></div>
                <div class="relative z-[1] flex h-full flex-col p-14 text-white">
                    <img :src="visualLogo" :alt="$store.state.settings.name" class="block h-7 w-auto self-start object-contain">
                    <div class="mt-auto max-w-[30rem]">
                        <img :src="visualMark" :alt="$store.state.settings.name" class="w-16 h-16 -ml-3 object-contain">
                        <p class="mt-4 text-base leading-relaxed text-white/80" v-html="visualText"></p>
                    </div>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
import LegalLinksMenu from "@/components/shared/legal-links-menu";

export default {
    name: "auth",
    components: {LegalLinksMenu},
    metaInfo() {
        return {
            title: this.$store.state.settings.name,
            titleTemplate: () => this.$store.state.settings.name
        }
    },
    computed: {
        pageContent() {
            const path = this.$route && this.$route.path ? this.$route.path : '';

            if (path.includes('/auth/register')) {
                return {
                    title: 'Schön, dass Sie da sind.',
                    description: 'Erstellen Sie Ihren Zugang, um direkt auf Ihre Arbeitsbereiche und geschützten Inhalte zugreifen zu können.'
                };
            }

            if (path.includes('/auth/recover')) {
                return {
                    title: 'Schön, dass Sie da sind.',
                    description: 'Geben Sie Ihre E-Mail-Adresse ein, um den Zugang zu Ihrem Account sicher wiederherzustellen.'
                };
            }

            if (path.includes('/auth/reset/')) {
                return {
                    title: 'Schön, dass Sie da sind.',
                    description: 'Vergeben Sie ein neues Passwort, um den sicheren Zugriff auf Ihren Account fortzusetzen.'
                };
            }

            return {
                title: 'Schön, dass Sie da sind.',
                description: 'Melden Sie sich an, um zu Ihrer persönlichen Administrationsoberfläche zu gelangen.'
            };
        },
        pageTitle() {
            return this.pageContent.title;
        },
        pageDescription() {
            return this.pageContent.description;
        },
        visualPanelStyle() {
            const backgroundImage = this.$store.state.settings.background;
            const style = {};

            if (backgroundImage) {
                style.backgroundImage = 'url(' + backgroundImage + ')';
            }

            return style;
        },
        visualLogo() {
            return this.$store?.state?.settings?.logo_invert
                || this.$store?.state?.settings?.logo
                || '/images/default/logo_invert.svg';
        },
        visualMark() {
            return this.$store?.state?.settings?.logo_toggle_invert
                || this.$store?.state?.settings?.logo_toggle
                || '/images/default/icon.png';
        },
        visualText() {
            return 'CORPRED<sup class="auth-registered-mark">&reg;</sup> entwickelt digitale Applikationen für effiziente Prozesse, klare Kommunikation und zukunftsweisende Arbeitsabläufe.';
        }
    }
}
</script>

<style lang="scss">
.auth-registered-mark {
    font-size: 0.52em;
    line-height: 0;
    vertical-align: super;
}

.auth-shell__visual-overlay {
    background:
        linear-gradient(145deg, rgba(32, 40, 48, 0.8), rgba(20, 25, 31, 0.9)),
        linear-gradient(180deg, rgba(32, 40, 48, 0.15), rgba(20, 25, 31, 0.62));
}
</style>
